import React, { useState } from 'react'

import { useInView } from 'react-cool-inview'

import { bool, string } from 'prop-types'

import BrowseAllButton from 'Pods/Shared/BrowseAllButton'
import ModelCarousel from 'Pods/Shared/Carousel/ModelCarousel'
import i18n from 'Pods/Shared/I18nHome'
import { modelsPath } from 'Pods/Shared/paths'
import DesignerModel from 'Pods/Shared/PrintModels/components/DesignerModel'

import useTrendingModels from './hooks/useTrendingModels'


function TrendingModelsSection({ locale = 'en', extractingCoreStyles = false }) {
  const [hasObserved, setHasObserved] = useState(false)
  const { observe, inView } = useInView({
    rootMargin: '200px',
    unobserveOnEnter: true,
  })

  const { trendingModels, sectionRef } = useTrendingModels({ perPage: 8 })
  const title = i18n.t('trendingSection.title', { ns: 'new-home', lng: locale } )
  const description = i18n.t('trendingSection.description', { ns: 'new-home', lng: locale } )
  const browseAllButton = i18n.t('trendingSection.browseButton', { ns: 'new-home', lng: locale } )
  const browseAllButtonPath = modelsPath(locale, {}, 'trending')
  const renderTrendingContent = () => (
    <>
      <div className="trending-models__header">
        <div className="trending-models__title-group">
          <h2 className="cgt-legacy-heading-h3">{title}</h2>
          <p className="trending-models__description cgt-legacy-text-default">
            {description}
          </p>
        </div>
        <BrowseAllButton
          href={browseAllButtonPath}
          className="browse-all-desktop"
          text={browseAllButton}
        />
      </div>

      {/* List view for desktop */}
      <div className="trending-models__list">
        {trendingModels?.map((model) => (
          <div key={model.id} className="trending-models__list-item">
            <DesignerModel {...model} lazyLoad />
          </div>
        ))}
      </div>

      {/* Carousel view for mobile */}
      <ModelCarousel models={trendingModels} />

      <BrowseAllButton href={browseAllButtonPath} className="browse-all-mobile" />
    </>
  )

  return (
    <div
      id="trending-models-section"
      className="new-home-section"
      ref={(element) => {
        if (!hasObserved) {
          setHasObserved(true)
          observe(element)
        }
        sectionRef.current = element
      }}
    >
      {(inView || extractingCoreStyles) && renderTrendingContent()}
      <noscript>{renderTrendingContent()}</noscript>
    </div>
  )
}

TrendingModelsSection.propTypes = {
  extractingCoreStyles: bool,
  locale: string,
}

export default TrendingModelsSection
